// extracted by mini-css-extract-plugin
export default {"root":"styles_root__cJL3K","logo":"styles_logo__RgYj9","responsive":"styles_responsive__Q89yY"};